import React from 'react';
import { Switch, Router, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import PrivateRoute from 'components/mainComponents/PrivateRoute';
import LeftMenu from 'components/mainComponents/LeftMenu';
import AppBar from 'components/mainComponents/AppBar';
import Login from 'pages/login';
import { NavBarProps } from 'models';
import { LOGIN } from 'constants/routes';

const history = createBrowserHistory();

const RoutesSwitch: React.FC<NavBarProps> = (props) => {
  const { isOpen, onClick: handleDrawerState } = props;

  return (
    <Router history={history}>
      <Switch>
        <Route path={LOGIN} component={Login} exact />
        <PrivateRoute>
          <AppBar isOpen={isOpen} onClick={handleDrawerState} />
          <LeftMenu isOpen={isOpen} onClick={handleDrawerState} />
        </PrivateRoute>
      </Switch>
    </Router>
  );
};

export default RoutesSwitch;
